import styled from "styled-components";

export const Nav = styled.nav`
  padding: 15px 0px 15px 0px;
  z-index: 45;
`;